export default "__VITE_ASSET__2tWE6PMZ__"